// extracted by mini-css-extract-plugin
module.exports = {"footer":"sticky-footer_footer__N3akM"};